import type { SupplierDocument } from '@tandemone/types'

import type { DocumentDownloadResult } from './document-preview-dialog'
import {
  type DocumentsGalleryTracking,
  DocumentsGallery
} from './documents-gallery'
import { ProfileSection } from './profile-section'

type Props = {
  companyName: string
  documents: SupplierDocument[]
  fetchUrl: (documentId: string) => Promise<DocumentDownloadResult>
  tracking?: DocumentsGalleryTracking
  collapsible?: boolean
  defaultOpen?: boolean
}

/** the supplier profile card wrapper. the gallery body lives in
 * DocumentsGallery so other surfaces (the company's own Documents page) can
 * reuse the carousel + table + preview without this section chrome. certs are
 * a separate entity now, surfaced by CertificatesGallery, not here.
 */
export function ProfileMedia({
  companyName,
  documents,
  fetchUrl,
  tracking,
  collapsible,
  defaultOpen
}: Props) {
  return (
    <ProfileSection title={`${companyName} Documents`}>
      <DocumentsGallery
        documents={documents}
        fetchUrl={fetchUrl}
        tracking={tracking}
        collapsible={collapsible}
        defaultOpen={defaultOpen}
      />
    </ProfileSection>
  )
}
